import { render } from "./UserLogin.vue?vue&type=template&id=8e044f9a&scoped=true&ts=true"
import script from "./UserLogin.vue?vue&type=script&lang=ts"
export * from "./UserLogin.vue?vue&type=script&lang=ts"

import "./UserLogin.vue?vue&type=style&index=0&id=8e044f9a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e044f9a"]])

export default __exports__